import apiClient, { unwrapResponse } from './client';
import * as T from '../../types/api';

export const clinicsApi = {
  getAll: (island?: string, page = 1, pageSize = 12) =>
    unwrapResponse<T.PaginatedResponse<T.Clinic>>(apiClient.get('/clinics', {
      params: { island, page, page_size: pageSize },
    })),

  getNearby: (lat: number, lng: number, radius = 5000, serviceId?: string, page = 1, pageSize = 12) =>
    unwrapResponse<T.PaginatedResponse<T.Clinic>>(apiClient.get('/clinics/nearby', {
      params: { lat, lng, radius, service_id: serviceId, page, page_size: pageSize },
    })),
  
  getBySlug: (slug: string) =>
    unwrapResponse<T.ClinicDetail>(apiClient.get(`/clinics/${slug}`)),
  
  getIslands: () =>
    unwrapResponse<T.Island[]>(apiClient.get('/clinics/islands')),
};

export const servicesApi = {
  getAll: async () => {
    const res = await unwrapResponse<T.PaginatedResponse<T.Service>>(apiClient.get('/services'));
    return res.items;
  },
  getGrouped: () => unwrapResponse<T.ServiceCategory[]>(apiClient.get('/services/grouped')),
};

export const appointmentsApi = {
  create: (data: T.AppointmentCreate) =>
    unwrapResponse<T.AppointmentCreated>(apiClient.post('/appointments', data)),
  
  getStatus: (token: string) =>
    unwrapResponse<T.Appointment>(apiClient.get(`/appointments/status/${token}`)),
  
  cancel: (token: string) =>
    unwrapResponse<T.Appointment>(apiClient.post(`/appointments/cancel/${token}`)),
};

export const triageApi = {
  assess: (symptoms: string) =>
    unwrapResponse<T.TriageResult>(apiClient.post('/triage/assess', { symptoms })),
};

export const waitTimeApi = {
  get: (clinicId: string) =>
    unwrapResponse<T.WaitTime>(apiClient.get(`/waittime/${clinicId}`)),
  
  report: (clinicId: string, minutes: number) =>
    unwrapResponse<T.WaitTime>(apiClient.post('/waittime', {
      clinic_id: clinicId,
      reported_minutes: minutes,
    })),
};
